import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _CheckRingDuotoneLine(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("circle", { cx: 12, cy: 12, r: 9, fill: "#7e869e", fillOpacity: 0.25, stroke: "currentColor", strokeWidth: 1.2 }),
            React.createElement("path", { stroke: "currentColor", strokeWidth: 1.2, d: "m8 12 3 3 5-6" })));
}
const CheckRingDuotoneLine = forwardRef(_CheckRingDuotoneLine);
export { CheckRingDuotoneLine };
